import React, { useState } from 'react';
import DUMMY_IMAGE from "../../assets/burger.jpg";
import { FaPizzaSlice, FaIceCream, FaTags } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, removeItem } from '../../Redux/orderSlice';
import { useNavigate } from 'react-router-dom';

const categories = [
  { label: 'Best Selling', icon: <FaTags />, active: true },
  { label: 'Dinner', icon: <FaPizzaSlice /> },
  { label: 'Lunch', icon: <FaTags /> },
  { label: 'Breakfast', icon: <FaTags /> },
  { label: 'Dessert', icon: <FaIceCream /> },
];

const products = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  name: 'Wagyu Black Pepper',
  price: 20.99,
  img: DUMMY_IMAGE,
}));

const ProductList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderItems = useSelector(state => state.order.items);
  const orderType = useSelector(state => state.order.orderType);
const table = useSelector(state => state.order.table);

  const [showCart, setShowCart] = useState(false);

  const getItemCount = (productId) => {
    const item = orderItems.find(item => item.id === productId);
    return item ? item.qty : 0;
  };

 const handleProductClick = (product) => {
      navigate("/productdetails")

  
  const existing = orderItems.find(item => item.id === product.id);
  if (existing) {
    dispatch({
      type: 'order/updateItem',
      payload: {
        index: orderItems.indexOf(existing),
        updatedItem: { ...existing, qty: existing.qty + 1 },
      },
    });
  } else {
    dispatch(addItem({ ...product, qty: 1 }));
  }
};

  const handleRemoveItem = (id) => {
    dispatch(removeItem(id));
  };

  const handleProceed = () => {
    if (orderItems.length === 0) {
      alert("Please select at least one item.");
    } else {
      navigate("/cart");
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-scroll bg-gray-50 relative">
      {/* Search */}
      <div className="p-4 pt-2 bg-white">
        <input
          type="text"
          placeholder="🔍 What you want to sell?"
          className="w-full p-2 rounded-full border text-sm"
        />
         

      </div>
      <div className="px-4 py-2 text-sm text-gray-700">
 
  {orderType === 'dinein' && table && (
    <p>
      Table Number: <span className="font-semibold">{String(table).padStart(2, '0')}</span>
    </p>
  )}
</div>

     <div className="flex flex-1 overflow-hidden">
  {/* Left Sidebar: Categories */}
  <div className="w-24 md:w-40 flex-shrink-0 overflow-y-auto bg-white border-r">
    {categories.map((cat, idx) => (
      <div
        key={idx}
        className={`flex flex-col items-center text-xs md:text-sm gap-1 p-2 rounded-xl m-2 ${
          cat.active ? 'bg-rose-600 text-white' : 'bg-rose-100 text-gray-700'
        }`}
      >
        <div className="text-lg">{cat.icon}</div>
        <span className="text-center">{cat.label}</span>
      </div>
    ))}
  </div>

  {/* Product and Cart Split */}
  <div className="flex flex-1 flex-col md:flex-row">
    {/* Product Grid - 70% */}
    <div className="w-full md:w-[70%] overflow-y-auto p-2 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {products.map((product, i) => (
        <div
          key={i}
          onClick={() => handleProductClick(product)}
          className="relative rounded-xl bg-white shadow-md min-h-[210px] cursor-pointer transition hover:shadow-lg"
        >
          <img
            src={product.img}
            alt={product.name}
            className="w-full h-24 md:h-32 object-cover rounded-t-xl"
          />
          <div className="p-2">
            <p className="text-sm font-semibold text-gray-800 truncate" title={product.name}>
              {product.name}
            </p>
            <p className="text-rose-600 font-bold text-sm mt-1">${product.price}</p>
          </div>
          {getItemCount(product.id) > 0 && (
            <span className="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-0.5 rounded-full shadow">
              x{getItemCount(product.id)}
            </span>
          )}
        </div>
      ))}
    </div>

    {/* Right Cart - 30% */}
    <div className="hidden md:flex md:flex-col md:w-[30%]  relative border-l bg-white p-4 overflow-y-auto">
      <h2 className="text-lg font-bold mb-2">Cart Summary</h2>
      {orderItems.length === 0 ? (
        <p className="text-gray-500 text-sm">No items yet</p>
      ) : (
        <ul className="space-y-3 text-sm">
          {orderItems.map((item) => (
            <li
              key={item.id}
              className="flex justify-between items-center bg-gray-100 p-2 rounded"
            >
              <div className="w-2/3">
                <p className="font-medium truncate">{item.name}</p>
                <span className="text-xs text-gray-500">Qty: {item.qty}</span>
              </div>
              <button
                onClick={() => handleRemoveItem(item.id)}
                className="text-xs text-primary hover:text-red-800"
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}

      {orderItems.length > 0 && (
        <button
          onClick={handleProceed}
          className="mt-4 bg-rose-600 absolute bottom-0  hover:bg-rose-700 text-white py-2 rounded text-sm font-semibold shadow-md w-full"
        >
          Proceed to Checkout
        </button>
      )}
    </div>
  </div>
</div>


     
     

     
    {/* Bottom Cart Popup */}
{orderItems.length > 0 && (
  <div className="fixed md:hidden bottom-0 h-52 overflow-scroll mb-10 left-0 right-0 bg-white border-t z-50 shadow-xl p-4">
    {/* Header Section */}
    <div className="flex justify-between items-center mb-3">
      <div>
        <p className="text-sm font-semibold text-gray-700">
          {orderType === "dinein" ? `Table ${String(table).padStart(2, "0")}` : "Takeaway"}
        </p>
        <p className="text-xs text-gray-500 capitalize">Order Type: {orderType}</p>
      </div>
      <button
        onClick={() => setShowCart(false)}
        className="text-xs text-rose-600 underline hover:text-rose-800 transition"
      >
        Clear All
      </button>
    </div>

    {/* Item List */}
    <div className="max-h-36 overflow-y-auto mb-3 scroll-smooth">
      <ul className="space-y-2 text-sm">
        {orderItems.map((item) => (
          <li
            key={item.id}
            className="flex justify-between items-center px-2 py-1 bg-gray-100 rounded"
          >
            <span className="truncate w-3/4">{item.name} × {item.qty}</span>
            <button
              onClick={() => handleRemoveItem(item.id)}
              className="text-xs text-red-500 hover:text-red-700"
            >
              ✕
            </button>
          </li>
        ))}
      </ul>
    </div>

    {/* Checkout Button */}
    <div className="sticky bottom-0">
      <button
        onClick={handleProceed}
        className="w-full bg-rose-600 hover:bg-rose-700 text-white py-2 rounded text-sm font-semibold shadow-md"
      >
        Proceed to Checkout
      </button>
    </div>
  </div>
)}




     
    </div>
  );
};

export default ProductList;
